import styles from './PageProductPortfolioValueSummaries.module.css';
import valueSummaries from './PageProductPortfolioValueSummaries.json';
import useSearchParamOrDefaultProps from '../hooks/useSearchParamOrDefaultProps.js';
import classNames from 'classnames';
import IconArrowRight from './IconArrowRight.js';
import LinkAuthFlow from './LinkAuthFlow.js';

function PageProductPortfolioValueSummaries() {
  const {
    productSku: product,
    heroSubcopy,
    callToActionDefaultText,
    pageProductFeatureLearnMoreUrl,
    valuePropositionTitleText,
  } = useSearchParamOrDefaultProps();
  const { summaryFields } = valueSummaries[product];

  return (
    <section className={styles.PageProductPortfolioValueSummaries}>
      <div className={styles.signInButtonContainerMobile}>
        <div className={styles.signInBtnSubTextMobile}>
          Already a subscriber?
        </div>
        <LinkAuthFlow
          className={styles.signInButtonMobile}
          product={'pro'}
          modalType={'signIn'}
          letterSpacing={'normal'}
          contentType={'livestream'}
        >
          Sign in{' '}
          <span>
            <IconArrowRight color="#000000" />
          </span>
        </LinkAuthFlow>
      </div>
      <div className={styles.heroFooterCnbcPlaidContainerMobile}>
        <div className={styles.heroFooterLogoContainerMobile}>
          <img
            src="/images/portfolio-hero-footer-cnbc-logo-mobile.svg"
            alt="cnbc"
          />
          <img
            src="/images/portfolio-hero-footer-arrows-logo-mobile.svg"
            alt="cnbc"
          />
          <img
            src="/images/portfolio-hero-footer-plaid-logo-mobile.svg"
            alt="cnbc"
          />
        </div>
        <div className={styles.heroFooterTextMobile}>
          <b>Plaid</b> uses secure encryption to help protect your data
        </div>
      </div>
      <div className={styles.subCopyMobile}>{heroSubcopy}</div>
      <div className={styles.valuePropositionTitle}>
        Drive smarter investment decisions when you upgrade to CNBC Pro for
        exclusive access to a range of features, including:
      </div>
      <div className={styles.portfolioPropsContainer}>
        {summaryFields.map(
          ({ heading, content, iconUrl, imageSrc, videoSrc }, i) => {
            return (
              <div className={styles.portfolioProp} key={heading}>
                <div className={styles.portfolioPropHeader}>
                  <span>
                    <img src={iconUrl} alt={heading} />
                  </span>
                  <span>{heading}</span>
                </div>
                <div className={styles.portfolioPropImage}>
                  <img src={imageSrc} width="100%" className={styles.image} />
                  <video
                    autoPlay
                    muted
                    loop
                    width="100%"
                    className={classNames(styles.video, {
                      [styles.newsVideo]: heading === 'Personalized News',
                    })}
                    src={videoSrc}
                  />
                </div>
                <div className={styles.portfolioPropcontent}>{content}</div>
              </div>
            );
          },
        )}
      </div>
      <div className={styles.subscribeContainer} id="subscribeBtn">
        <button className={styles.subscribeButton}>
          <LinkAuthFlow
            contentType={'page'}
            modalType={'signUp'}
            productSku={product}
            className={styles.basicCallToActionPortfolio}
          >
            {callToActionDefaultText}
          </LinkAuthFlow>
        </button>
        <button className={styles.learnMoreBtn}>
          <a
            href={pageProductFeatureLearnMoreUrl}
            target="_blank"
            rel="noreferrer"
          >
            LEARN MORE
          </a>
        </button>
      </div>
      <div className={styles.valuePropositionTitle}>
        {valuePropositionTitleText}
      </div>
    </section>
  );
}

export default PageProductPortfolioValueSummaries;
